import { ReactComponent as ShortLinkArrow } from "../../../../../../assets/Icons/Pages/Organizational/Management/Activities/ShortLinkArrow.svg";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
const UpcomingExamCard = ({ title, description, path }) => {
  const navigate = useNavigate();
  const handelRedirect = (_path) => {
    if (_path === "") return;
    navigate(_path);
  };

  return (
    <button
      className="flex align-center justify-center radius-10 border-greenColor greenBack relative pointer"
      style={{
        width: "20rem",
        height: "6rem",
        padding: "26px 24px",
      }}
      onClick={() => handelRedirect(path)}
    >
      <div className="flex-col align-start justify-start g-05">
        <span className="color-greenColor poppins t-16 text-wrap-none">
          {title}
        </span>
        <div className="flex-row align-center justify-between w-full">
          <span className="t-14 poppins color-black">{description}</span>
        </div>
        <div
          style={{
            border: "none",
            position: "absolute",
            top: "55%",
            right: "13%",
          }}
        >
          <ShortLinkArrow fill="var(--greenColor)" style={{ width: "18px" }} />
        </div>
      </div>
    </button>
  );
};

export default UpcomingExamCard;

UpcomingExamCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};
